import classes from './Title.module.css';

const Title = (props) => {
  const className = `${classes.title} ${props.className}`;

  return <h2 className={className}>{props.children}</h2>;
};

export default Title;
